import React, { useState } from "react";
import Card from "@/components/Card";
import { DashType } from "@/features/dashboard";
import { Col, Row } from "antd";


import { PerformanceContext } from "./hook";
import Chart from "./Chart";
import CountrySelect from "./CountrySelect";
import LeftPane from "./LeftPane"


export default () => {
  const [country, setCountry] = useState<string[]>(["singapore"]);
  const [selectedKey, setSelectedKey] = useState<DashType.PerformanceType[]>(["change"]);

  return (
    <PerformanceContext.Provider value={{ country, setCountry, selectedKey, setSelectedKey }}>
      <Card
        title={"Sector & Industry Performance"}
        extra={<CountrySelect/>}
      >
        <Row>
          <Col span={2}>
            <LeftPane/>
          </Col>
          <Col span={22}>
            <Chart />
          </Col>
        </Row>

      </Card>
    </PerformanceContext.Provider>
  );
};
